import { render, staticRenderFns } from "./StatusModal.vue?vue&type=template&id=dfc70e86&scoped=true&"
import script from "./StatusModal.vue?vue&type=script&lang=js&"
export * from "./StatusModal.vue?vue&type=script&lang=js&"
import style0 from "./StatusModal.vue?vue&type=style&index=0&id=dfc70e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc70e86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfc70e86')) {
      api.createRecord('dfc70e86', component.options)
    } else {
      api.reload('dfc70e86', component.options)
    }
    module.hot.accept("./StatusModal.vue?vue&type=template&id=dfc70e86&scoped=true&", function () {
      api.rerender('dfc70e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages-mobile/components/StatusModal.vue"
export default component.exports